import React from 'react'
import './CardRapport.css' // We will create this shared css file

const CardRapportTwin = ({el}) => {
  return (
    <div className="rapport-card">
      <div className="rapport-card-header">
        <span className="rapport-location"><i className="fas fa-map-marker-alt"></i> {el.localisation}</span>
        <span className="rapport-date">{new Date(el.DateCollect).toLocaleDateString('fr-FR')}</span>
      </div>
      <div className="rapport-card-body">
        <div className="rapport-stat">
          <span className="rapport-label">Total Amount</span>
          <span className="rapport-value success">{el.TotalAmount || 0} TND</span>
        </div>
        <div className="rapport-stat">
          <span className="rapport-label">Dont TPE</span>
          <span className="rapport-value info" style={{ color: '#17a2b8' }}>{el.TotalTpe || 0} TND</span>
        </div>
        <div className="rapport-stat">
          <span className="rapport-label">Daily Expenses</span>
          <span className="rapport-value danger">{el.DailyExpenses || 0} TND</span>
        </div>
        {el.PlayZoneKids > 0 && (
          <div className="rapport-stat" style={{ fontSize: '0.85rem' }}>
            <span className="rapport-label" style={{ color: '#8b5cf6', fontWeight: '600' }}>PlayZone Kids 🎈</span>
            <span className="rapport-value" style={{ color: '#8b5cf6', fontWeight: '600' }}>{el.PlayZoneKids} TND</span>
          </div>
        )}
        {el.carRaceDetails && el.carRaceDetails.length > 0 ? (
          <div className="rapport-stat flex-column align-items-start" style={{ fontSize: '0.85rem' }}>
            <div className="d-flex justify-content-between w-100">
              <span className="rapport-label" style={{ color: '#d97706', fontWeight: '600' }}>🏎️ Car Race Total</span>
              <span className="rapport-value" style={{ color: '#d97706', fontWeight: '600' }}>
                {el.carRaceDetails.reduce((acc, c) => acc + (c.amount || 0), 0)} TND
              </span>
            </div>
            <div className="ps-2 small text-muted">
              {el.carRaceDetails.map((c, idx) => (
                <span key={idx} className="me-2" style={{ color: c.color || '#666' }}>
                  {c.name}: {c.amount || 0} DT
                </span>
              ))}
            </div>
          </div>
        ) : (((el.CarRaceJaune || 0) + (el.CarRaceNoir || 0) + (el.CarRaceRougeS || 0) + (el.CarRaceRougeB || 0)) > 0) && (
          <div className="rapport-stat" style={{ fontSize: '0.85rem' }}>
            <span className="rapport-label" style={{ color: '#d97706', fontWeight: '600' }}>🏎️ Car Race Total</span>
            <span className="rapport-value" style={{ color: '#d97706', fontWeight: '600' }}>
              {((el.CarRaceJaune || 0) + (el.CarRaceNoir || 0) + (el.CarRaceRougeS || 0) + (el.CarRaceRougeB || 0))} TND
            </span>
          </div>
        )}
        {(el.TaxiExpenses || el.RepairExpenses || el.StaffAdvance || el.MiscPurchases || el.OtherExpenses) > 0 && (
          <div className="expenses-breakdown" style={{ fontSize: '0.8rem', color: '#666', paddingLeft: '10px' }}>
            {el.TaxiExpenses > 0 && <div>Taxi: {el.TaxiExpenses}</div>}
            {el.RepairExpenses > 0 && <div>Réparation: {el.RepairExpenses}</div>}
            {el.StaffAdvance > 0 && <div>Avance: {el.StaffAdvance}</div>}
            {el.MiscPurchases > 0 && <div>Achats Divers: {el.MiscPurchases}</div>}
            {el.OtherExpenses > 0 && <div>Autres: {el.OtherExpenses}</div>}
          </div>
        )}
        <div className="rapport-stat highlight-stat">
          <span className="rapport-label">Net</span>
          <span className="rapport-value">{(el.TotalAmount || 0) - (el.DailyExpenses || 0)} TND</span>
        </div>
      </div>
      {el.feedback && (
        <div className="rapport-card-footer">
          <span className="feedback-label">Explication:</span>
          <p>{el.feedback}</p>
        </div>
      )}
    </div>
  )
}

export default CardRapportTwin